class FeaturedStrip {
	constructor( el ) {

		let textScroll = el.querySelector(".block-featured-strip__text-scroll--outline");
		if ( textScroll !== null ) {

			function textOverlapPosition() {

				let textScrollFull = el.querySelector(".block-featured-strip__text-scroll--full");
				let textScrollFullLeft = textScrollFull.getBoundingClientRect().left;
				let textScrollOutlineLeft = textScroll.getBoundingClientRect().left;
				let textScrollDifference = textScrollOutlineLeft - textScrollFullLeft;

				textScroll.style.transform = "translateX(-" + textScrollDifference +"px)";
			}

			textOverlapPosition();
			window.addEventListener('resize', function(event){
				textOverlapPosition();
			});

			function moveVideoElement() {
				let contentColumn = el.querySelector(".block-featured-strip__content-column");
				let imageColumn = el.querySelector(".block-featured-strip__image-column");
				let videoElement = el.querySelector(".block-featured-strip__video-wrap");

				if (window.innerWidth < 768) {
					contentColumn.appendChild(videoElement);
				} else {
					imageColumn.appendChild(videoElement);
				}
			}

			moveVideoElement();
			window.addEventListener('resize', function(event){
				moveVideoElement();
			});

		}

	}
}

export default FeaturedStrip;
